import React from 'react';
import RecentlyDeletedList from './recently-deleted-list';
import BackButton from 'components/base/back-button';
import { LOGISTICS_ROUTE_KEYS } from 'utils/constants';

const RecentlyDeleted = () => {
  return (
    <div>
      <div className='space-y-6'>
        <BackButton link={LOGISTICS_ROUTE_KEYS.OVERVIEW} text='Back to overview' />
        <h1 className=' text-lg md:text-2xl font-semibold'>Riders({0})</h1>
        <RecentlyDeletedList list={[]} />
      </div>
    </div>
  );
};

export default RecentlyDeleted;
